import React from 'react';
import { MapPin, Navigation, Headphones, Settings } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  MapPin: MapPin,
  Navigation: Navigation,
  Headphones: Headphones,
  Settings: Settings
};

export const WhyChooseSection = () => {
  return (
    <section id="why-us" className="relative flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden py-20">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      {/* Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5">
        <h1 className="text-[5rem] md:text-[12rem] font-bold text-white select-none">
          PRIMESWIFT
        </h1>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-blue-500/20 backdrop-blur-sm border border-blue-400/30 rounded-full">
            <span className="text-blue-300 text-sm font-semibold">WHY PRIMESWIFT</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            Excellence in Every Delivery
          </h2>
          <p className="text-base md:text-xl text-gray-300 max-w-2xl mx-auto">
            Partner with India's fastest-growing logistics network built on trust, technology, and transparency
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group relative"
                style={{
                  animation: `fadeInScale 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 h-full hover:bg-white/10 hover:border-blue-400/50 transition-all duration-300">
                  <div className="mb-6">
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
                      <Icon className="h-7 w-7 text-white" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Trust Indicators */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { icon: '🏆', text: 'ISO Certified' },
            { icon: '🔒', text: 'Insured Cargo' },
            { icon: '⚡', text: 'Express Delivery' },
            { icon: '💯', text: 'On-Time Guarantee' }
          ].map((badge, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl mb-2">{badge.icon}</div>
              <div className="text-white font-medium">{badge.text}</div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </section>
  );
};
